/** Prevent browser password manager autofill on membership PIN fields. */
export const handleMembershipPinFocus = (event) => {
	event.target.readOnly = false;
};

export const getMembershipPinInputProps = (section, index) => ({
	type: 'text',
	inputMode: 'numeric',
	pattern: '[0-9]*',
	autoComplete: 'off',
	autoCorrect: 'off',
	autoCapitalize: 'off',
	spellCheck: false,
	'data-lpignore': 'true',
	'data-1p-ignore': 'true',
	'data-form-type': 'other',
	name: `membership-pin-${section}-${index}`,
	readOnly: true,
	onFocus: handleMembershipPinFocus,
});

export const MembershipPinAutofillTrap = () => (
	<div
		aria-hidden="true"
		style={{
			position: 'absolute',
			width: 0,
			height: 0,
			overflow: 'hidden',
			opacity: 0,
			pointerEvents: 'none',
		}}
	>
		<input type="text" name="fake-membership-user" autoComplete="username" tabIndex={-1} />
		<input type="password" name="fake-membership-pass" autoComplete="current-password" tabIndex={-1} />
	</div>
);
